
import zh from '../assets/languages/zh.json'

export default{
    isLogin:function(_this){
        if(!_this.$store.getters.getLoginValue){
            return _this.$router.push("Login")
        }
    },
    // 多语言字段兼容：旧数据可能是逗号/竖线分隔；现仅繁体中文，优先取中文段
    pickLangText:function(source, sep){
        if (!source) return ''
        const parts = String(source).split(sep || ',').map(function (s) { return (s || '').trim() })
        const at = function (i) { return parts[i] || '' }
        const first = function () {
            for (var i = 0; i < parts.length; i++) {
                if (parts[i]) return parts[i]
            }
            return String(source)
        }
        // 旧4段：中,英,日,西 → 取中文；其余格式取首段
        if (parts.length >= 4) {
            return at(0) || first()
        }
        return first()
    },
    // 投注结果文案：与 zh.json reservation.rose/lily/balloon/fireworks 保持一致
    lotteryLabel:function(type){
        const map = (zh && zh.reservation) ? zh.reservation : {}
        return map[type] || ''
    }
}
